// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Text } from '@mantine/core';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { BookitupNotification } from '../../../../Types/LogT';
import LinkText from '../../../../Atoms/LinkText';

const CalendarUnreachable: FC<{ notification: BookitupNotification }> = ({ notification }) => {
  const { value } = notification;
  const navigate = useNavigate();

  return (
    <Text>
      Der Kalender{' '}
      <Text span weight="bolder">
        {value}
      </Text>{' '}
      konnte nicht abgerufen werden. Bitte prüfe deine{' '}
      <LinkText span weight="bolder" onClick={() => navigate(`/settings/calendar`)}>
        Kalender-Einstellungen
      </LinkText>
      .
    </Text>
  );
};

export default CalendarUnreachable;
